    <!-- <div id="app" v-if="this.list !=undefined"> -->
  <template>
    <div id="peticion-formulario-vue">
  <form-wizard :id="idform" ref="peticionForm" :title="title" subtitle="" color="#7993FC" errorColor="#c77878" next="Siguiente">
    <div v-if="mensaje_error != ''" class="alert alert-danger">
        {{mensaje_error}}
    </div>
  <div v-if="this.peticion_oferta == undefined ">
  <tab-content id="tipo-servicio" name="tipo-servicio">

      <form>
        <div class="row">
          <div class="col-12 botones">
            <div class="centrar" style="margin-top:40px">

              <button class="ico_btn" @click.prevent="setTipoPeticion('mecanica')"><img src="../images/mecanica.jpg" /><p>Mecánica</p></button>
              <button class="ico_btn" @click.prevent="setTipoPeticion('carroceria')"><img src="../images/carroceria.jpg" /><p>Carrocería</p></button>
              <!-- <button class="ico_btn"><a href="/neumaticos"><img src="/images/iconos/Dark/alloy-wheel.png" /><p>Neumáticos</p></a></button> -->
              <button class="ico_btn" @click.prevent="setTipoPeticion('neumaticos')"><img src="../images/neumaticos.jpg" /><p>Neumáticos</p></button>

              <button class="ico_btn" @click.prevent="setTipoPeticion('lavado')"><img src="../images/lavado.jpg" /><p>Lavado</p></button>
              <button class="ico_btn" @click.prevent="setTipoPeticion('electricidad')"><img src="../images/electricidad.jpg" /><p>Electricidad</p></button>
              <button class="ico_btn" @click.prevent="setTipoPeticion('lunas')"><img src="../images/lunas.jpg" /><p>Lunas</p></button>
              <button class="ico_btn" @click.prevent="setTipoPeticion('transporte')"><img src="../images/grua.jpg" /><p>Grúa</p></button>
             <!-- <button class="ico_btn" @click.prevent="setTipoPeticion('valoracion')"><img src="/images/iconos/Dark/car-sale.png" /><p>Valoración</p></button> -->
              <button class="ico_btn"><a href="https://www.dsimobility.es/renting-listado/#/"><img src="../images/renting.jpg" /><p>Renting</p></a></button>
              <!-- <button class="ico_btn"> <a href="https://dsimobility.es/market"> <img src="../images/marketplace.jpg" /><p>MarketPlace</p></a></button> -->
              <!--<a href="#" class="ico_btn"><i class="fa fa-truck" aria-hidden="true"></i><p>Transporte</p></a>
              <a href="#" class="ico_btn"><i class="fa fa-recycle" aria-hidden="true"></i><p>Tasación</p></a>
              <a href="#" class="ico_btn"><i class="fa fa-usd" aria-hidden="true"></i><p>Valoración</p></a>
              <a href="#" class="ico_btn"><i class="fa fa-sticky-note" aria-hidden="true"></i><p>Multas</p></a>-->
            </div>
          </div>
          <!--<div class="col-2 botones">
              <button type="submit">Enviar</button>
          </div>-->
        </div>
    </form>

    </tab-content>
  </div>

<tab-content v-if="tipo_peticion_private && mensaje_peticiones_deshabilitadas == '' || this.peticion_oferta != undefined" id="vehiculo" :before-change="validaPasoUno" name="vehiculo">
  <div>
    <form  @submit.prevent="" data-vv-scope="paso1">
    <div class="row">
      <div class="progreso">
        <div v-if="tipo_peticion_private == 'mecanica'" class="centrar-servicio col-sm-12"><span><img src="../images/mecanica.jpg" /> <p><strong>Servicio de {{ this.getTipoString(tipo_peticion_private) }}</strong></p></span></div>
        <div v-if="tipo_peticion_private == 'carroceria'" class="centrar-servicio col-sm-12"><span><img src="../images/chapa.jpg" /> <p><strong>Servicio de {{ this.getTipoString(tipo_peticion_private) }}</strong></p></span></div>
        <div v-if="tipo_peticion_private == 'neumaticos'" class="centrar-servicio col-sm-12"><span><img src="../images/neumaticos.jpg" /> <p><strong>Servicio de {{ this.getTipoString(tipo_peticion_private) }}</strong></p></span></div>
        <div v-if="tipo_peticion_private == 'lavado'" class="centrar-servicio col-sm-12"><span><img src="../images/lavado.jpg" /> <p><strong>Servicio de {{ this.getTipoString(tipo_peticion_private) }}</strong></p></span></div>
        <div v-if="tipo_peticion_private == 'electricidad'" class="centrar-servicio col-sm-12"><span><img src="../images/electricidad.jpg" /> <p><strong>Servicio de {{ this.getTipoString(tipo_peticion_private) }}</strong></p></span></div>
        <div v-if="tipo_peticion_private == 'lunas'" class="centrar-servicio col-sm-12"><span><img src="../images/lunas.jpg" /> <p><strong>Servicio de {{ this.getTipoString(tipo_peticion_private) }}</strong></p></span></div>
        <div v-if="tipo_peticion_private == 'transporte'" class="centrar-servicio col-sm-12"><span><img src="../images/grua.jpg" /> <p><strong>Servicio de {{ this.getTipoString(tipo_peticion_private) }}</strong></p></span></div>
        <div v-if="tipo_peticion_private == 'renting'" class="centrar-servicio col-sm-12"><span><img src="../images/renting.jpg" /> <p><strong>Servicio de {{ this.getTipoString(tipo_peticion_private) }}</strong></p></span></div>
        <!-- <div v-if="tipo_peticion_private == 'market'" class="centrar-servicio col-sm-12"><span><img src="../images/market.jpg" /> <p><strong>Servicio de {{ this.getTipoString(tipo_peticion_private) }}</strong></p></span></div> -->
        <div style="width:100%;" class="col-sm-12">&nbsp;</div>
        <div v-if="tipo_peticion_private == 'mecanica'" style="width:100%;" class="col-sm-12">
          <div class="centrar-servicio">
            <p>Mantenimiento, revisión y reparación de averías con garantía oficial de las principales marcas, fabricantes y seguros del automóvil. Servicio de taller mecánico que disfrute de tu coche con total tranquilidad.</p>
            <p>Si necesitas un servicio más específico, indíquelo más adelante, gracias.</p>
          </div>
        </div>
        <div v-if="tipo_peticion_private == 'carroceria'" style="width:100%;" class="col-sm-12">
          <div class="centrar-servicio">
            <p>En nuestro taller contamos con pintores y carroceros profesionales expertos en carrocería. Cuidamos el exterior de tu coche. Si has sufrido un pequeño arañazo, roce o abolladura, una colisión o buscas renovar la imagen de tu vehículo estas en el lugar adecuado.</p>
            <p>Si necesitas un servicio más específico, indíquelo más adelante, gracias.</p>
          </div>
        </div>
        <div v-if="tipo_peticion_private == 'neumaticos'" style="width:100%;" class="col-sm-12">
          <div class="centrar-servicio">
            <p>Venta y montaje de neumáticos, llantas o ruedas para tu coche. Nuestro servicio de neumáticos te ofrece gran variedad de marcas tanto económicas como premium. Especialistas en ruedas, con la mejor tecnología de alineación, paralelo y equilibrado. Tu seguridad es lo primero.</p>
            <p>Si necesitas un servicio más específico, indíquelo más adelante, gracias.</p>
          </div>
        </div>
        <div v-if="tipo_peticion_private == 'lavado'" style="width:100%;" class="col-sm-12">
          <div class="centrar-servicio">
            <p>Nuestro servicio de lavado exterior, con pulido y encerado, y de interior, con desinfección y aromatización opcional hará que tu coche luzca como nuevo. Lavado a mano y con maquinaría de última tecnología. Deja el lavado de tu coche en nuestras manos y presume de vehículo.</p>
            <p>Si necesitas un servicio más específico, indíquelo más adelante, gracias.</p>
          </div>
        </div>
        <div v-if="tipo_peticion_private == 'transporte'" style="width:100%;" class="col-sm-12">
          <div class="centrar-servicio">
            <p>Servicio de grúa para particulares. En caso de avería, accidente o comodidad disfruta del mejor servicio de grúa. Llámanos y recogemos tu coche, moto, furgoneta o industrial para traerlo a nuestro taller. Económico y eficaz</p>
            <p>Si necesitas un servicio más específico, indíquelo más adelante, gracias.</p>
          </div>
        </div>
        <div v-if="tipo_peticion_private == 'lunas'" style="width:100%;" class="col-sm-12">
          <div class="centrar-servicio">
            <p>Sustitución y cambio de lunas. Servicio ultra rápido de cambio de cristales en tu coche, ya sea el parabrisas, lunas o ventanas traseras o laterales. Trabajamos todas las marcas del automóvil y con las principales aseguradoras. Rápido, fácil y económico.</p>
            <p>Si necesitas un servicio más específico, indíquelo más adelante, gracias.</p>
          </div>
        </div>
        <div v-if="tipo_peticion_private == 'electricidad'" style="width:100%;" class="col-sm-12">
          <div class="centrar-servicio">
            <p>Reparación de cualquier fallo o avería en el sistema eléctrico de tu coche de gasolina, diésel, híbrido o eléctrico. Nuestro servicio de electricidad del automóvil, con los últimos avances tecnológicos de análisis y diagnosis, solventa cualquier problema electrónico de tu vehículo.</p>
            <p>Si necesitas un servicio más específico, indíquelo más adelante, gracias.</p>
          </div>
        </div>
     </div>

      <div v-if="this.peticion_oferta != undefined" class="oferta_seleccionada">
        <img class="col-12 center-block" v-if="this.peticion_oferta_img && this.peticion_oferta_img != ''" :src="this.peticion_oferta_img" />

        <h3>{{peticion_oferta_title}}</h3>
        <div class="descripcion" v-html="this.peticion_oferta_description"></div>
        <p v-if="this.peticion_oferta_precio == '' || this.peticion_oferta_precio == 0 || this.peticion_oferta_precio == 'Según presupuesto'" class="precio"><strong>Precio: </strong>Según presupuesto</p>
        <p v-else class="precio"><strong>Precio: </strong>{{peticion_oferta_precio}}€</p>
      </div>
      <div class="col-sm-12">
          <label class="label">Matrícula:</label>
          <div class="control has-icon has-icon-right" style="padding-bottom:15px">
            <input type="text" v-model="matricula" :debounce="matricula_delay" placeholder="" style="text-transform: uppercase;" />
            <div v-if="loading " class="loading-mini matricula-loader" >
              <div v-if="!finished" class="loading" style="padding:0"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>
            </div>

          </div>
      </div>
      <div class="col-sm-12">
        <span v-show="matricula_status != ''" class="matricula_help alert " :class="{'alert-danger':!matricula_ok,'alert-success':matricula_ok}"><i v-show="!matricula_ok" class="fa fa-exclamation-triangle"></i><i v-show="matricula_ok" class="fa fa-check"></i>{{matricula_status}}</span>
      </div>
      <div class="col-sm-12 vehiculo" v-show="marca != ''">
          <div class="">
            <p><strong>Marca:</strong> {{marca}}</p>
            <p><strong>Modelo:</strong> {{modelo}}</p>

          </div>
      </div>

     <div v-if="this.tipo_peticion_private == 'tasacion' || this.tipo_peticion_private == 'valoracion'" class="col-sm-12">
            <label class="label">Kilómetros</label>
            <p class="control has-icon has-icon-right">
                <input name="kilometros" v-model="kilometros" data-vv-as="kilometros"  v-validate="''" :class="{'input': true, 'is-danger': errors.has('paso1.kilometros') }" type="text" placeholder=""/>
                <span  v-show="errors.has('paso1.kilometros')" class="alert alert-danger">
                  <i class="fa fa-exclamation-triangle"></i>
                  <span class="help is-danger" >{{ errors.first("paso1.kilometros") }}</span>
                </span>
            </p>
      </div>
      <div v-else class="col-sm-12">
        <label class="label">Kilómetros</label>
        <p class="control has-icon has-icon-right">
            <input name="kms" v-model="kms" data-vv-as="kms"  v-validate="''" :class="{'input': true, 'is-danger': errors.has('paso1.kms') }" type="text" placeholder=""/>
            <span  v-show="errors.has('paso1.kms')" class="alert alert-danger">
              <i class="fa fa-exclamation-triangle"></i>
              <span class="help is-danger" >{{ errors.first("paso1.kms") }}</span>
            </span>
        </p>
      </div>
      <div v-if="this.tipo_peticion_private == 'tasacion'" class="col-sm-12">
            <label class="label">Código motor</label>
            <p class="control has-icon has-icon-right">
                <input name="codigo_motor" v-model="codigo_motor" data-vv-as="kilómetros"  v-validate="''" :class="{'input': true, 'is-danger': errors.has('paso1.codigo_motor') }" type="text" placeholder=""/>
                <span v-show="errors.has('paso1.codigo_motor')" class="alert alert-danger">
                  <i class="fa fa-exclamation-triangle"></i>
                  <span class="help is-danger">{{ errors.first('paso1.codigo_motor') }}</span>
                </span>
            </p>

        </div>
        <div v-if="this.tipo_peticion_private == 'tasacion'" class="col-sm-12">
            <label class="label">Valor esperado</label>
            <p class="control has-icon has-icon-right">
                <input name="valor_esperado" v-model="valor_esperado" data-vv-as="kilómetros"  v-validate="''" :class="{'input': true, 'is-danger': errors.has('paso1.valor_esperado') }" type="text" placeholder=""/>
                <span v-show="errors.has('paso1.valor_esperado')" class="alert alert-danger">
                  <i class="fa fa-exclamation-triangle"></i>
                  <span class="help is-danger">{{ errors.first('paso1.valor_esperado') }}</span>
                </span>
            </p>

        </div>

    <!-- <div v-if="this.tipo_peticion_private == 'transporte'">
      <div class="row">
      <div class="col-sm-12" >
        <h3>Recogida:</h3>
        <br />
      </div>
      <div class="col-sm-6">
          <label class="label">Fecha</label>
            <p class="control has-icon has-icon-right">
              <datepicker :monday-first=true format="dd-MM-yyyy" :language="es" name="fecha_rec" v-model="fecha_rec"  data-vv-as="Fecha de recogida"  v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('paso1.fecha_rec') }" ></datepicker>
                <span v-show="errors.has('paso1.fecha_rec')" class="alert alert-danger">
                  <i class="fa fa-exclamation-triangle"></i>
                  <span class="help is-danger">{{ errors.first('paso1.fecha_rec') }}</span>
                </span>
            </p>
        </div>

        <div class="col-sm-6">
            <label class="label">Hora</label>
            <p class="control has-icon has-icon-right">
                <input type="time" pattern="[0-9]{2}:[0-9]{2}" name="hora_rec" v-model="hora_rec" data-vv-as="hora recogida"  v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('paso1.hora_rec') }" />
                <span v-show="errors.has('paso1.hora_rec')" class="alert alert-danger">
                  <i class="fa fa-exclamation-triangle"></i>
                  <span class="help is-danger">{{ errors.first('paso1.hora_rec') }}</span>
                </span>
            </p>
        </div>-->

      <!-- <div class="col-sm-6">
          <label class="label">Provincia</label>
          <p class="control has-icon has-icon-right">
            <select name="cod_provincia_rec" id="cod_provincia_rec" v-model="cod_provincia_rec"  data-vv-as="provincia recogida"   v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('paso1.cod_provincia_rec') }">
              <option v-for="provincia_nombre, clave in provincias_listado" :value="clave">
              <option v-for="provincia_nombre in provincias_listado" :value="provincia_nombre['id']" :key="provincia_nombre['id']">
                {{provincia_nombre}}
              </option>
            </select>
              <span v-show="errors.has('paso1.cod_provincia_rec')" class="alert alert-danger">
                <i class="fa fa-exclamation-triangle"></i>
                <span class="help is-danger">{{ errors.first('paso1.cod_provincia_rec') }}</span>
              </span>
          </p>
      </div> -->
      <!-- <div class="col-sm-6">
          <label class="label">Población</label>
          <p class="control has-icon has-icon-right">
            <select name="cod_localidad_rec" id="cod_localidad_rec" v-model="cod_localidad_rec"  data-vv-as="población recogida"   v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('paso1.cod_localidad_rec') }" >
              <option v-for="localidad_nombre, clave in localidad_listado_rec" :value="clave">
                {{localidad_nombre}}
              </option>
            </select>
            <span v-show="errors.has('paso1.cod_localidad_rec')" class="alert alert-danger">
                <i class="fa fa-exclamation-triangle"></i>
                <span class="help is-danger">{{ errors.first('paso1.cod_localidad_rec') }}</span>
              </span>
          </p>
      </div> -->

      <!--<div class="col-sm-12">
          <label class="label">Dirección</label>
          <p class="control has-icon has-icon-right">
              <input name="direccion_rec" v-model="direccion_rec" data-vv-as="dirección recogida"  v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('paso1.direccion_rec') }" type="text" placeholder="" />
              <span v-show="errors.has('paso1.direccion_rec')" class="alert alert-danger">
                <i class="fa fa-exclamation-triangle"></i>
                <span class="help is-danger">{{ errors.first('paso1.direccion_rec') }}</span>
              </span>
          </p>
      </div>

      <div class="col-sm-12">
          <label class="label">Observaciones</label>
          <p class="control has-icon has-icon-right">
              <textarea name="observaciones_rec" v-model="observaciones_rec" data-vv-as="observaciones recogida"  v-validate="''" :class="{'input': true, 'is-danger': errors.has('paso1.observaciones_rec') }" type="text" placeholder=""> </textarea>
              <span v-show="errors.has('paso1.observaciones_rec')" class="alert alert-danger">
                <i class="fa fa-exclamation-triangle"></i>
                <span class="help is-danger">{{ errors.first('paso1.observaciones_rec') }}</span>
              </span>
          </p>
      </div>

      <div class="col-sm-12">
        <h3>Entrega:</h3>
        <br />
      </div>

      <div class="col-sm-6">
          <label class="label">Fecha</label>
          <p class="control has-icon has-icon-right">
            <datepicker :monday-first=true format="dd-MM-yyyy" :language="es" name="fecha_ent" v-model="fecha_ent"  data-vv-as="Fecha de entrega"  v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('paso1.fecha_ent') }" ></datepicker>
              <span v-show="errors.has('paso1.fecha_ent')" class="alert alert-danger">
                <i class="fa fa-exclamation-triangle"></i>
                <span class="help is-danger">{{ errors.first('paso1.fecha_ent') }}</span>
              </span>
          </p>
      </div>
      <div class="col-sm-6">
          <label class="label">Hora</label>
          <p class="control has-icon has-icon-right">
              <input type="time" pattern="[0-9]{2}:[0-9]{2}" name="hora_ent" v-model="hora_ent" data-vv-as="hora entrega"  v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('paso1.hora_ent') }" />
              <span v-show="errors.has('paso1.hora_ent')" class="alert alert-danger">
                <i class="fa fa-exclamation-triangle"></i>
                <span class="help is-danger">{{ errors.first('paso1.hora_ent') }}</span>
              </span>
          </p>
      </div>-->

      <!-- <div class="col-sm-6">
          <label class="label">Provincia</label>
          <p class="control has-icon has-icon-right">
            <select name="cod_provincia_ent" v-model="cod_provincia_ent"  data-vv-as="provincia entrega"  v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('paso1.cod_provincia_ent') }" >

               <option v-for="provincia_nombre, clave in provincias_listado" :value="clave">
              <option v-for="provincia_nombre in provincias_listado" :value="provincia_nombre['id']" :key="provincia_nombre['id']">                {{provincia_nombre}}
              </option>

            </select>
              <span v-show="errors.has('paso1.cod_provincia_ent')" class="alert alert-danger">
                <i class="fa fa-exclamation-triangle"></i>
                <span class="help is-danger">{{ errors.first('paso1.cod_provincia_ent') }}</span>
              </span>
          </p>
      </div> -->
      <!--<div class="col-sm-6">
          <label class="label">Población</label>
          <p class="control has-icon has-icon-right">
            <select name="cod_localidad_ent" v-model="cod_localidad_ent"  data-vv-as="población recogida"  v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('paso1.cod_localidad_ent') }">
               <option v-for="provincia_nombre in localidad_listado_ent" :value="provincia_nombre['id_poblacion']">
               <option v-for="provincia_nombre in localidad_listado_ent" :value="provincia_nombre['id_poblacion']" :key="provincia_nombre['id_poblacion']">
                {{provincia_nombre['denominacion']}}
              </option>
            </select>
              <span v-show="errors.has('paso1.cod_localidad_ent')" class="alert alert-danger">
                <i class="fa fa-exclamation-triangle"></i>
                <span class="help is-danger">{{ errors.first('paso1.cod_localidad_ent') }}</span>
              </span>
          </p>
      </div>-->

      <!--<div class="col-sm-12">
          <label class="label">Dirección</label>
          <p class="control has-icon has-icon-right">
              <input name="direccion_ent" v-model="direccion_ent" data-vv-as="dirección"  v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('paso1.direccion_ent') }" type="text" placeholder=""/>
              <span v-show="errors.has('paso1.direccion_ent')" class="alert alert-danger">
                <i class="fa fa-exclamation-triangle"></i>
                <span class="help is-danger">{{ errors.first('paso1.direccion_ent') }}</span>
              </span>
          </p>
      </div>

      <div class="col-sm-12">
          <label class="label">Observaciones</label>
          <p class="control has-icon has-icon-right">
              <textarea name="observaciones_ent" v-model="observaciones_ent" data-vv-as="observaciones entrega"  v-validate="''" :class="{'input': true, 'is-danger': errors.has('paso1.observaciones_ent') }" type="text" placeholder=""> </textarea>
              <span v-show="errors.has('paso1.observaciones_ent')" class="alert alert-danger">
                <i class="fa fa-exclamation-triangle"></i>
                <span class="help is-danger">{{ errors.first('paso1.observaciones_ent') }}</span>
              </span>
          </p>
      </div>
    </div>
  </div> -->
<div v-if="this.peticion_oferta == undefined" class="" style="width:100%;">
    <label v-if="this.tipo_peticion_private == 'valoracion' || this.tipo_peticion_private == 'tasacion'" class="label">Descríbenos brevemente el estado en el que está tu vehículo actualmente para poder valorarlo lo mejor posible.</label>
    <label v-else="" class="label">¿Qué necesitas?</label>
    <p class="control has-icon has-icon-right">
    <textarea name="descripcion" v-model="descripcion" data-vv-as="descripción"  v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('paso1.descripcion') }" type="text" placeholder=""></textarea>
    <span v-show="errors.has('paso1.descripcion')" class="alert alert-danger">
        <i class="fa fa-exclamation-triangle"></i>
        <span class="help is-danger">{{ errors.first('paso1.descripcion') }}</span>
    </span>
    </p>
<div>

                <!-- <div v-if="this.peticion_oferta == undefined" class="file-upload-form">
                  <label>Imágenes:</label>
                    <div id="dropzone"  :class="{hover:drop_hover}" @dragover.prevent:="drop_hover=true" @dragleave.prevent:="drop_hover=false" >
                      <h3>Arrastre aquí sus ficheros o realize click en este recuadro.</h3>
                      <input multiple="true" name="file" type="file" @drop.prevent:="$event.stopPropagation()" @change="previewImage($event,1)" accept="image/*" >
                      <div class="image-preview row" v-if="images.length > 0">
                        <div class="col-lg-3 col-md-6" v-for="image in images" :key="image['id']">
                          <div class="card">
                            <img class="" :src="image" style="width:100%">
                          </div>
                          <span class="vue-remove-file alert  alert-danger" @drop.prevent:="$event.stopPropagation()" @click="images.splice(key, 1);">
                            <span aria-hidden="true">&times;</span>
                          </span>
                        </div>
                      </div>

                    </div>
                </div> -->
            </div>
        </div>
        <!-- <MultipleFileUploader postURL="http://www.google.es" successMessagePath="http://www.google.es" errorMessagePath="errorMessagePath"  :minItems="0" :maxItems="5" headerMessage="Añadir imagenes" dropAreaPrimaryMessage="Arrastra sus ficheros aquí" dropAreaSecondaryMessage="o haga click en subir fichero" fileNameMessage="Nombres" fileSizeMessage="Tamaño" totalFileMessage="Total ficheros:" totalUploadSizeMessage="Tamaño total de subida:" removeFileMessage="Eliminar" uploadButtonMessage="Subir fichero" cancelButtonMessage="Cancelar" fileUploadErrorMessage="Ha ocurrido un error" maxFilesErrorMessage="Máximo número de ficheros permitido" retryErrorMessage="Por favor, eliminar los archivos y inténtalo de nuevo" httpMethodErrorMessage="Error interno"></MultipleFileUploader>-->
        <!--<vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions">
        </vue-dropzone> -->
        </div>
      </form>
</div>

</tab-content>
<tab-content v-if="tipo_peticion_private || this.peticion_oferta != undefined" :before-change="validateBeforeSubmit">

     <div v-if="mensaje_peticiones_deshabilitadas != ''" class="">
       {{mensaje_peticiones_deshabilitadas}}

       <tellamamos :tipo_peticion="tipo_peticion_private"></tellamamos>
     </div>
     <div v-else="">
       <div v-if="loading">
         <div v-if="!finished" class="loading"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>
       </div>
       <form v-else="" @submit.prevent="" data-vv-scope="paso2">
         <div class="row">
         <div v-if="is_logued_in">

           <p class="" style="padding:11px;background:rgba(0,0,0,0.05);">
             <i class="fas fa-question-circle" style="font-size:18px;margin-right:9px;"></i> Esta petición se está realizando para el usuario: <span v-if="login_name">{{login_name}}</span><span v-else="">{{login_email}}</span><br />
             <strong>Teléfono: </strong> {{login_phone}}
             <br />
             <br />
             <a v-if="logueado_rol != 3" href="#" @click.prevent="is_logued_in = false;" class="btn">Realizar petición para otro usuario</a>
           </p>

         </div>
         <div v-if="!is_logued_in" class="col-sm-12 ">

             <p class="" style="padding:11px;background:rgba(0,0,0,0.05);">
               <i class="fas fa-question-circle" style="font-size:18px;margin-right:9px;"></i> Indícanos tus datos para que podamos ayudarte de una forma personalizada.
             </p>
         </div>

          <div v-if="dni_activo" class="col-sm-12 ">
              <label class="label">Dni (obligatorio)</label>
              <p class="control has-icon has-icon-right">
                  <input name="dni" v-model="dni" v-validate="'required|min:9|max:10'" :class="{'input': true, 'is-danger': errors.has('paso2.dni') }" type="text" placeholder="">
                  <span v-show="errors.has('paso2.dni')" class="alert alert-danger">
                    <i class="fa fa-exclamation-triangle"></i>
                    <span class="help is-danger">{{ errors.first('paso2.dni') }}</span>
                  </span>
              </p>
          </div>

         <div v-if="!is_logued_in" class="col-sm-12 ">
             <label class="label">Email (obligatorio)</label>
             <p class="control has-icon has-icon-right">
                 <input name="email" v-model="email" v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('paso2.email') }" type="text" placeholder="">
                 <span v-show="errors.has('paso2.email')" class="alert alert-danger">
                   <i class="fa fa-exclamation-triangle"></i>
                   <span class="help is-danger">{{ errors.first('paso2.email') }}</span>
                 </span>
             </p>
         </div>
          <div v-if="!is_logued_in || !this.login_phone " class="col-sm-12">
              <label class="label">Teléfono (obligatorio)</label>
              <p class="control has-icon has-icon-right">
                  <input name="telefono" v-model="telefono"  data-vv-as="teléfono" v-validate="'required|numeric|min:9|max:10'" :class="{'input': true, 'is-danger': errors.has('paso2.telefono') }" type="text" placeholder="">
                  <span v-show="errors.has('paso2.telefono')" class="alert alert-danger">
                    <i class="fa fa-exclamation-triangle"></i>
                    <span class="help is-danger">{{ errors.first('paso2.telefono') }}</span>
                  </span>
              </p>
          </div>
          <div v-if="!is_logued_in || !this.login_name" class="col-sm-12">
              <label class="label">Nombre completo</label>
              <p class="control has-icon has-icon-right">
                  <input name="nombre" v-model="nombre" v-validate="''" :class="{'input': true, 'is-danger': errors.has('paso2.nombre') }" type="text" placeholder="">
                  <span v-show="errors.has('paso2.nombre')" class="alert alert-danger">
                    <i class="fa fa-exclamation-triangle"></i>
                    <span class="help is-danger">{{ errors.first('paso2.nombre') }}</span>
                  </span>
              </p>
          </div>

         <div  v-if="!is_logued_in">

            <div class="col-sm-12">
                <label class="label">Código postal</label>
                <p class="control has-icon has-icon-right">
                    <input name="codigo_postal" v-model="codigo_postal" v-validate="''" :class="{'input': true, 'is-danger': errors.has('paso2.codigo_postal') }" type="text" placeholder="">
                    <span v-show="errors.has('paso2.codigo_postal')" class="alert alert-danger">
                      <i class="fa fa-exclamation-triangle"></i>
                      <span class="help is-danger">{{ errors.first('paso2.codigo_postal') }}</span>
                    </span>
                </p>
            </div>

            <div class="col-sm-12">
              <p class="control">
            <label class="checkbox">
                <input name="terms"  v-validate="'required'" type="checkbox" data-vv-as="política de privacidad" style="width:15px;height:15px;float:left;">
                <p>Acepto las <a href="https://delfingrupo.eu/condiciones-de-uso/" target="_blank">condiciones de uso</a>, <a href="/politica-privacidad" target="_blank">política de privacidad</a> y <a href="https://delfingrupo.eu/consentimiento-de-la-lopdgdd/" target="_blank">consentimiento de la ley de protección de datos</a>. </p>
            </label>
            <span v-show="errors.has('paso2.terms')" class="alert alert-danger">
              <i class="fa fa-exclamation-triangle"></i>
              <span class="help is-danger">{{ errors.first('paso2.terms') }}</span>
            </span>

        </p>
            </div>
         </div>
       </div>
      </form>
    </div>
</tab-content>
<template slot="footer" slot-scope="props">
  <div v-if="!loading && !finished">

       <div class=wizard-footer-left>
           <wizard-button v-if="props.activeTabIndex > 0 " @click.native="props.prevTab();clickAtras();" :style="props.fillButtonStyle" name="anterior" id="anterior">Anterior</wizard-button>
        </div>
        <div class="wizard-footer-right">
          <wizard-button v-if="(props.activeTabIndex > 0 || peticion_oferta != undefined ) && mensaje_peticiones_deshabilitadas == ''" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle" name="siguiente" id="siguiente">{{props.isLastStep ? 'Finalizar' : 'Siguiente'}}</wizard-button>
        </div>
      </div>
    <div v-else-if="finished">
      <div class=wizard-footer-left>
      </div>
        <div class="wizard-footer-right">
          <!-- <wizard-button class="wizard-footer-right" :style="props.fillButtonStyle" name="finalizar" id="finalizar" data-dismiss="modal" @click="modalClose()">Finalizar</wizard-button> -->
        </div>
    </div>
    <div v-else-if="mensaje_error != ''">
      <div class=wizard-footer-left>
          <wizard-button v-if="props.activeTabIndex > 0 " @click.native="props.prevTab();clickAtras();" :style="props.fillButtonStyle" name="anterior" id="anterior">Anterior</wizard-button>
       </div>
       <div class="wizard-footer-right">
         <wizard-button v-if="(props.activeTabIndex > 0 || peticion_oferta != undefined ) && mensaje_peticiones_deshabilitadas == ''" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle" name="siguiente" id="siguiente">{{props.isLastStep ? 'Finalizar' : 'Siguiente'}}</wizard-button>
       </div>
    </div>
   </template>
     <div class="mensaje_ok" v-if="finished">
       <h1>Petición realizada correctamente</h1>
       <p>En breve nos pondremos en contacto con usted para continuar el proceso.</p>
       <button class="another_request" @click.prevent="resetForm">Realizar otra petición</button>
       </div>

</form-wizard>

</div>
</template>

<script type='text/javascript' src='http://ajax.googleapis.com/ajax/libs/jquery/1.3.2/jquery.min.js'></script>
<script src="https://cdn.jsdelivr.net/npm/vue-resource@1.3.5"></script>
<script>
import Datepicker from 'vuejs-datepicker';
import {en, es} from 'vuejs-datepicker/dist/locale'
//import axios from "axios";
    //var app = new Vue({
    export default {
      name: 'PeticionForm',
      props: ['dni_activo','logueado','logueado_rol','login_name','login_email','login_phone','taller_preferido', 'taller_nombre','tipo_peticion','api_key','referer',"peticion_oferta","peticion_oferta_title","peticion_oferta_description","peticion_oferta_precio","peticion_oferta_img","matricula","kms"],
      components:{
        Datepicker
       //  FormWizard,
       // TabContent,
       // WizardStep,
       // ValidationProvider
      },
      created(){
        var that = this
        console.log(this.tipo_peticion);
        if (this.tipo_peticion != undefined && this.tipo_peticion != ""){
          this.tipo_peticion_private = this.tipo_peticion;
        // setTimeout(function(){
        //   that.$children["0"].nextTab()
        // },1);
      }
      if(this.matricula != undefined && this.matricula != "")
      {
        this.matricula_private = this.matricula;
        return this.comprobarMatricula();
      }
      if(this.kms != undefined && this.kms != "")
      {
        this.kms_private = this.kms;
      }
      this.is_logued_in = this.logueado;
      if(this.api_key=='uNNpCdkwTAXlBPsHnJdRzkvHhYSVf0Arr2Gf26/3n 684DLBE0Q6NNSC1noMTmu2 9MYqrr6TIQi8Bhsy/9U/kwts')
      {
        this.clase="dsimobility";
        this.color="#7993FC";
        this.idform="dsimobility";
      }else{
        this.clase="";
        this.color="#ffca36";
        this.idform="yonder";
      }
  },
      data () {
          return{
            //id:1,
            title:'',
            tipo_peticion_private:'',
            mensaje_peticiones_deshabilitadas :'',
            descripcion: 'Descripcion 1',
            marca: '',
            modelo: '',
            vin: '',
            makecode : '',
            umc : '',
            brand_normalized : '',
            //matricula:'',
            matricula_private:'',
            kms_private:'',
            //link:'/dsimobility_principal',
            link:'',
            is_logued_in:false,
            drop_hover:false,
            images:[],
            images_save:[],
            imageData: "",  // we will store base64 format of image in this string
            descripcion:"",
            matricula_delay:1000,
            loading: false,
            finished: false,
            msg: 'Formulario peticion',
            primer_paso_validated: false,
            matricula_status: '',
            matricula_ok: false,
            marca: '',
            modelo: '',
            email: "",
            nombre: "",
            telefono: "",
            codigo_postal: "",
            mensaje_error: "",
            dni: "",
            // Transporte:
            // Recogida:
            fecha_rec:"",
            hora_rec:"11:00",
            cod_provincia_rec:"0",
            cod_localidad_rec:"0",
            direccion_rec:"",
            observaciones_rec:"",
            // Entrega:
            fecha_ent:"",
            hora_ent:"12:00",
            cod_provincia_ent:"0",
            cod_localidad_ent:"0",
            direccion_ent:"",
            observaciones_ent:"",
            //Provincias
            provincias_listado:{"0":"Cargando...."},
            localidad_listado_rec:{"0":"-"},
            localidad_listado_ent:{"0":"-"},
            // TASACION Y VALORACION
            kilometros:"",
            // Tasación
            codigo_motor:"",
            valor_esperado:"",
            //Para aplicar diferente estilos si viene de dsimobility
            clase:"",
            // Dropzone
      dropzoneOptions: {
          url: 'http://localhost',
          thumbnailWidth: 150,
          maxFilesize: 0.5,
          headers: { "My-Awesome-Header": "header value" },
          acceptedFileTypes:['png','jpg','jpeg'],
          showRemoveLink:true,
          maxFileSizeInMB:1,
          maxNumberOfFiles:5,
          autoProcessQueue:true,
          headers:{ "My-Awesome-Header": "header value" },
          language:"es"
      },
      en: en,
      es: es
          }
      },
      methods: {
        modalClose(){
          setTimeout(function(){

          },20000);
        },
        isRequired(value) {
          return value ? true : 'This field is required';
        },
        getTipoString: function (tipo) {
      if (tipo == 'valoracion'){
        return 'Valoración'
      }
      else if(tipo == 'mecanica'){
        return 'Mecánica';
      }
      else if(tipo == 'carroceria'){
        return 'Carrocería';
      }
      else if(tipo == 'neumaticos'){
        return 'Neumaticos';
      }
      else if(tipo == 'renting'){
        return 'Renting';
      }
      else if(tipo == 'tasacion'){
        return 'Reciclaje';
      }
      else if(tipo == 'multas'){
        return 'Multas';
      }
      else if(tipo == 'transporte'){
        return 'Transporte';
      }else if(tipo == 'lavado'){
        return 'Lavado';
      }else if(tipo == 'market'){
        return 'Market';
      }else if(tipo == 'lunas'){
        return 'Lunas';
      }else if(tipo == 'electricidad'){
        return 'Electricidad';
      }
    },
    setTipoPeticion: function (event) {
      // Comprobamos si es igual, ya que en ese caso el disparador watch no se disparará y no pasará al siguiente paso del formulario
      var aux = this.tipo_peticion_private;
      // `this` inside methods points to the Vue instance
      this.tipo_peticion_private = event;
      // console.log('Tipo Petición');
      // console.log(this.tipo_peticion_private);
      // console.log(aux);
      if (this.tipo_peticion_private == aux){
        this.$children["0"].nextTab()
      }

    },
        humanizeURL: function (url) {
          //console.log(this.list.length);
          return url
            .replace(/^https?:\/\//, '')
            .replace(/\/$/, '')
        },
        resetForm() {
            this.$children["0"].reset()
      Object.assign(this.$data, this.$options.data.call(this));
      if (this.tipo_peticion != undefined && this.tipo_peticion != ""){
        this.tipo_peticion_private = this.tipo_peticion;
        /*setTimeout(function(){
          that.$children["0"].nextTab()
        },1);*/
      }
      this.is_logued_in = this.logueado;
    },
        validaMatricula: function(that){
          this.mensaje_error = "";
          that=this;
          that.loading = true;
          that.marca = '';
          that.modelo = '';
          var respuesta='';
          var link=this.link;

      (function($) {
          $.ajax({
              async:false,
              type: "POST",
              url: link+'/wp-content/themes/Avada-Child-Theme/peticion/lib/obtenerModelop.php',
              data: { "matricula": that.matricula},
              crossDomain: true,
              dataType: 'json',
              success : function(data){
                if(data)
                {
                  if(data.result == true){
                    that.loading = false;
                    that.marca = data.data.data.brand;
                    that.modelo = data.data.data.model;
                    that.vin = data.data.data.vin;
                    that.makecode = data.data.data.makecode;
                    that.umc = data.data.data.umc;
                    that.brand_normalized = data.data.data.brand_normalized;
                    that.matricula_status = "Matricula correcta";
                    that.matricula_ok = true;
                  }
                  else{
                    that.loading = false;
                    that.matricula_status = "No se pudo encontrar el modelo";
                    that.matricula_ok = true;
                  }
                }else{
                  that.loading = false;
                  that.matricula_status = "No se pudo encontrar el modelo";
                  that.matricula_ok = true;
                }
              }
            }).fail( function( jqXHR, textStatus, errorThrown ) {
                  that.loading = false;
                  that.matricula_status = "No se pudo encontrar el modelo";
                  that.matricula_ok = true;
                  /*var data=[
            {result: true},
            {data : [
                {success : true},
                {data: [
                      {brand : "KIA"},
                      {model : "NIRO (C) 5P (16-19)"},
                      {vin : "KNACB81CGJ5152558"},
                      {makecode : "KI1"},
                      {umc: "KI02501"},
                      {brand_normalized : "KIA"}]},
                {message : "Vehicle data obtained succesfully."}]}];
                console.log(data[1].data[1].data[0].brand);
                    if(data)
                    {
                      if(data[0].result == true){
                        that.loading = false;
                        that.marca = data[1].data[1].data[0].brand;
                        that.modelo = data[1].data[1].data[0].model;
                        that.vin = data[1].data[1].data[0].vin;
                        that.makecode = data[1].data[1].data[0].makecode;
                        that.umc = data[1].data[1].data[0].umc;
                        that.brand_normalized = data[1].data[1].data[0].brand_normalized;
                        that.matricula_status = "Matricula correcta";
                        that.matricula_ok = true;
                      }
                      else{
                        that.loading = false;
                        that.matricula_status = "No se pudo encontrar el modelo";
                        that.matricula_ok = true;
                      }
                    }else{
                      that.loading = false;
                      that.matricula_status = "No se pudo encontrar el modelo";
                      that.matricula_ok = true;
                    }*/
            });
          })(jQuery);
            return false;
      },
        comprobarMatricula: function (event) {
            this.mensaje_error = "";
            var that =this;
            that.matricula_ok = false;

            this.matricula = this.matricula.toUpperCase();
            this.matricula = this.matricula.replace(/[^a-z0-9]/gi,'');
            if (that.matricula == ""){
              that.matricula_status = 'Introduce tu matrícula';
              that.matricula_ok = false;
            }
            else{
              var expreg = /^(\d{4}[\D\w]{3}|[\D\w]{1,2}\d{4}[\D\\w]{1,2})$/;
              if(expreg.test(that.matricula)){
                that.matricula_status = "Comprobando matricula";
                if (that.matricula_ok){
                  that.matricula_status = "Matricula correcta";
                  if (!that.primer_paso_validated){
                    return false;
                  }
                  else{
                    return true;
                  }
                }
                this.validaMatricula(that);
              }
              else{
                that.matricula_ok = false;
                that.loading = false;
                that.matricula_status = "Formato de matrícula: 0000AAA ó A0000AA";
                return false;
              }
            }
          },
          validaPasoUno:function(){
            //console.log('En Valida paso uno');
              if(this.mensaje_peticiones_deshabilitadas != ''){
                return true;
              }
              this.mensaje_error = "";
              return this.$validator.validateAll("paso1").then((result) => {
                if (result) {
                  this.primer_paso_validated = true;
                  return true;
                }
                else{
                  this.primer_paso_validated = false;
                  return false;
                }
            });
          },
          clickAtras:function(){
            if (this.$children["0"].activeTabIndex == 0){
              this.$children["0"].reset()

              this.tipo_peticion_private = '';
            }
          },
          validateBeforeSubmit() {
              if(this.mensaje_peticiones_deshabilitadas != ''){
                return true;
              }
              this.mensaje_error = "";
              this.$validator.validateAll("paso2").then((result) => {
                if (result) {
                  //console.log('Validando paso 2');
                  this.loading = true;
                  // eslint-disable-next-line
                  var that = this;
                  var tipo_peticion = 0;
                  var clase='';
                  var data = {
                    matricula:that.matricula,
                    email:that.email,
                    nombre:that.nombre,
                    telefono:that.telefono,
                    cp:that.codigo_postal,
                    marca:that.marca,
                    modelo:that.modelo,
                    vin: that.vin,
                    makecode: that.makecode,
                    umc: that.umc,
                    brand_normalized: that.brand_normalized,
                    terminos:1,
                    api_key:that.api_key,
                    referer:that.referer,
                    taller_preferido:that.taller_preferido,
                    dni:that.dni,
                    funcion:'solicitarPeticion'
                    };
                  var labelpeticion = "";
                  if (that.peticion_oferta == undefined){
                    if (that.tipo_peticion_private == "mecanica"){
                      tipo_peticion = 6;
                    }
                    else if (that.tipo_peticion_private == "carroceria"){
                      tipo_peticion = 5;
                    }
                    else if (that.tipo_peticion_private == "transporte"){
                      tipo_peticion = 2;
                    }
                    else if (that.tipo_peticion_private == "valoracion"){
                      tipo_peticion = 9;
                    }
                    else if (that.tipo_peticion_private == "tasacion"){
                      tipo_peticion = 3;
                    }else if (that.tipo_peticion_private == "multas"){
                      tipo_peticion = 4;
                    }else if (that.tipo_peticion_private == "neumaticos"){
                      tipo_peticion = 10;
                    }else if (that.tipo_peticion_private == "lavado"){
                      tipo_peticion = 11;
                    }else if (that.tipo_peticion_private == "electricidad"){
                      tipo_peticion = 15;
                    }else if (that.tipo_peticion_private == "lunas"){
                      tipo_peticion = 2;
                    }
                    data["tipo"] = tipo_peticion;
                    data["descripcion"] = that.descripcion;
                    labelpeticion = that.tipo_peticion_private;

                  }else{
                    data["oferta"] = that.peticion_oferta;
                    data["oferta_titulo"] = that.peticion_oferta_title;
                    data["oferta_descripcion"] = that.peticion_oferta_description;
                    console.log(data);
                    labelpeticion = "oferta-" + that.peticion_oferta;
                  }

                  if (typeof ga != "undefined"){
                    ga('send', {
                       hitType: 'event',
                       eventCategory: 'formulario',
                       eventAction: 'enviar',
                       eventLabel: labelpeticion,
                     });
                  }

                  if (that.is_logued_in){
                    data["email"] = that.login_email;
                    if (that.login_name){
                      data["nombre"] = that.login_name;
                    }
                    if (that.login_phone){
                      data["telefono"] = that.login_phone;

                    }
                }
                /*  images.length > 0">
                    <div class="col-lg-3 col-md-6" v-for="image,key in images
        */
              if (that.tipo_peticion_private == "transporte"){
                data["fecha_rec"] = that.fecha_rec;
                data["hora_rec"] = that.hora_rec;
                data["cod_provincia_rec"] = that.cod_provincia_rec;
                data["cod_localidad_rec"] = that.cod_localidad_rec;
                data["direccion_rec"] = that.direccion_rec;
                data["observaciones_rec"] = that.observaciones_rec;

                data["fecha_ent"] = that.fecha_ent;
                data["hora_ent"] = that.hora_ent;
                data["cod_provincia_ent"] = that.cod_provincia_ent;
                data["cod_localidad_ent"] = that.cod_localidad_ent;
                data["direccion_ent"] = that.direccion_ent;
                data["observaciones_ent"] = that.observaciones_ent;

              }

              if (that.tipo_peticion_private == "tasacion" || that.tipo_peticion_private == "valoracion"){
                data["kilometros"] = that.kilometros;
              }

              if (that.tipo_peticion_private == "tasacion"){
                data["codigo_motor"] = that.codigo_motor;
                data["valor_esperado"] = that.valor_esperado;
              }

          var setHeader = {'Access-Control-Allow-Origin': '*'};

          (function($) {
            $.ajax({
                async:false,
                type: "POST",
                //url: 'http://localhost/dsimobility/vuejs/prueba/src/components/lib/solicitar_peticion.php',
                //url: 'http://localhost/dsimobility/vuejs/prueba/src/components/lib/solicitud.php',
                url: that.link+'/wp-content/themes/Avada-Child-Theme/peticion/lib/solicitud.php',
                data: { data },
                crossDomain: true,
                dataType: 'json',
                headers: setHeader,
                success: function(response){
                  if(response.status == 200){
                    if(response.data.success == true){
                       that.finished = true;
                       that.loading = true;
                       that.$children["0"].maxStep = -1;
                     }
                    else{
                      for(var kk in response.data.msg){
                        for(var kk2 in response.data.msg[kk]){
                          that.errors.add(kk,response.data.msg[kk][kk2])
                        }
                      }
                      that.loading = false;
                      that.mensaje_error= 'Revisa los errores para continuar';
                     }
                  }else{
                      that.loading = false;
                      that.mensaje_error= 'Error '+response.data.status;
                  }
                },
                error: function(error){
                  that.loading = false;
                    that.mensaje_error= 'Error'+error;
                }
              }).fail( function( jqXHR, textStatus, errorThrown ) {
                    that.loading = false;
                    that.mensaje_error = 'Error ';

              });
            })(jQuery);
              this.finished=that.finished;
              this.loading=that.loading;
              return false;
              }
                //alert('Correct them errors!');
              });
            }

      },
      watch: {
        cod_provincia_rec:function (val){
          var that = this;
          console.log($("#cod_provincia_rec selected").val());
          console.log(val);
          var provincia=val;
          console.log(provincia);
          this.mensaje_error = "";
          that.loading = true;
          var respuesta='';
          var setHeader = {'Access-Control-Allow-Origin': '*'}
          $.ajax({
              async:false,
              type: "POST",
              //url: 'http://localhost/dsimobility/vuejs/prueba/src/components/obtenerDatos.php',
              url: 'http://localhost/dsimobility/vuejs/prueba/src/components/obtenerDatos.php',
              data: {'funcion' : 'getCiudades', 'provincia' : provincia },
              crossDomain: true,
              dataType: 'json',
              headers: setHeader,
              success: function(data){
                  alert(data.result);
                  if(data.result == true){
                    that.cod_localidad_rec = "0"
                    that.loading = false;
                    that.localidad_listado_rec = data.data.localidades;
                    console.log(that.localidad_listado_rec);
                  }
                  else{
                    that.loading = false;
                    that.localidad_listado_rec = {"0":"Error al cargar listado"}

                  }
              }
            });
            return false;
          },
          cod_provincia_ent:function (val){

            var that = this;
            var provincia=val;
            this.mensaje_error = "";
            that.loading = true;
            var respuesta='';
            var setHeader = {'Access-Control-Allow-Origin': '*'}
            $.ajax({
                async:false,
                type: "POST",
                url: 'http://localhost/dsimobility/vuejs/prueba/src/components/obtenerDatos.php',
                data: {'funcion' : 'getCiudades', 'provincia':provincia },
                crossDomain: true,
                dataType: 'json',
                headers: setHeader,
                success: function(data){
                    console.log(data);
                    if(data.result == true){
                      that.loading = false;
                      that.localidad_listado_ent = data.data.localidades;
                      console.log(that.localidad_listado_ent);
                    }
                    else{
                      that.loading = false;
                      that.localidad_listado_ent = {"0":"Error al cargar listado"}

                    }
                }
              });
              return false;
        },
        matricula: function (val) {
          return this.comprobarMatricula();
        },
        tipo_peticion_private: function (val) {
      this.mensaje_error = "";
      this.mensaje_peticiones_deshabilitadas = "";
      var that = this;

      if (typeof ga != "undefined"){
        ga('send', {
           hitType: 'event',
           eventCategory: 'formulario',
           eventAction: 'abrir',
           eventLabel: val,
         });

      }

      // `event` is the native DOM event
      console.log(val);
      if (val == "mecanica" || val == "carroceria" || val == "transporte" || val == "valoracion" || val == "tasacion" || val == "multas" || val == "neumaticos" || val == "lavado" || val == "electricidad"|| val == "lunas"){

        // if (val == "transporte"){
        //   this.mensaje_error = "";
        //   that.loading = true;
        //   var respuesta='';
        //   var setHeader = {'Access-Control-Allow-Origin': '*'}
        //   $.ajax({
        //       async:false,
        //       type: "POST",
        //       url: 'http://localhost/dsimobility/vuejs/prueba/src/components/obtenerDatos.php',
        //       data: {'funcion' : 'getProvincia' },
        //       crossDomain: true,
        //       dataType: 'json',
        //       headers: setHeader,
        //       success: function(data){
        //
        //           if(data.result == true){
        //             that.loading = false;
        //             that.provincias_listado = data.data.provincias;
        //             console.log(that.provincias_listado);
        //           }
        //           else{
        //             that.loading = false;
        //             that.provincias_listado = {"0":"Error al cargar listado"}
        //
        //           }
        //       }
        //     });
        //     return false;
        //     // axios.post('obtenerDatos.php', {}, { crossdomain: true, headers: { 'Content-Type': 'multipart/form-data' }  } )
        //     // .then(function (response) {
        //     //   if (response.status == 200){
        //     //     that.provincias_listado = response.data.provincias
        //     //   }
        //     //   else{
        //     //     that.provincias_listado = {"0":"Error al cargar listado"}
        //     //
        //     //   }
        //     //
        //     // })
        //     // .catch(function (error) {
        //     //   that.provincias_listado = {"0":"Error al cargar listado"}
        //     //
        //     // });
        // }

        this.$nextTick(function() {
          this.$children["0"].changeTab(0,1);
        });
      }
      else{
        if (val != ""){
          //this.mensaje_error = "No disponible en estos momentos. Disculpe las molestias.";
          //this.$children["0"].nextTab()

          this.mensaje_peticiones_deshabilitadas = 'Introduzca su teléfono y le llamaremos para tramitar esta gestión.';
          this.$nextTick(function() {
            this.$children["0"].changeTab(0,1);
          });

          //this.$children["0"].activeTabIndex = 2;
          /*this.$children["0"].$forceUpdate();
          this.$children["0"].nextTab();*/
          //this.$children["0"].nextTab();

          //this.tipo_peticion_private = '';
          //this.$children["0"].reset()
        }
        else{

        }
      }

      return val;
    },
    tipo_peticion: function (val) {
        this.tipo_peticion_private = val;

      return val;
    }
      }
    }
  </script>
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#dropzone{display:block;position:relative;outline:2px dashed #ccc;padding:0 50px 0;}
#dropzone h3{display:block;position:relative;text-align:center;top:0;left:0;bottom:0;width:100%;vertical-align:middle;padding-top:50px;padding-bottom:50px}
#dropzone.hover{outline:3px dashed #999;}
#dropzone input[type="file"]{display:block;position:absolute;top:0;left:0;right:0;bottom:0;width:100%;background:rgba(0,0,0,0.5);opacity:0;z-index:15}
#dropzone .card button{display:block;position:absolute;top:0;right:0;z-index:16;}
#dropzone .card{margin-bottom:50px}
.oferta_seleccionada{background:#f4f4f4;padding:15px;margin-bottom:15px;}
.oferta_seleccionada .descripcion{font-size:13px}
.vue-remove-file{display: block;
  cursor: pointer;
  z-index: 8888;
  position: absolute;
  right: 0;
  top: 0;
  width: 30px;
  height: 30px;
  line-height: 0px;
  font-size: 34px;
  padding: 0;
  margin: 0;}

.vue-remove-file span{
  font-size: 42px;
  display: block;
  text-align: center;
  width: 100%;
  position: absolute;
  top: 0;
  line-height: 28px;
}

.peticion-formulario-vue select{width:100%}
.peticion-formulario-vue select {
    color: #000;
    background: #fff;
    border: 0 solid rgba(0,0,0,.5);
    box-shadow: 0 0 0 .1rem rgba(0,0,0,.1);
    padding: 10px 20px;
}

.peticion-formulario-vue input {
    color: #000;
    background: #fff;
    border: 0 solid rgba(0,0,0,.5);
    box-shadow: 0 0 0 .1rem rgba(0,0,0,.1);
    padding: 10px 20px;
}

.peticion-formulario-vue textarea {
    color: #000;
    background: #fff;
    border: 0 solid rgba(0,0,0,.5);
}

.peticion-formulario-vue textarea {
    color: #000;
    background: #fff;
    border: 0 solid rgba(0,0,0,.5);
    box-shadow: 0 0 0 .1rem rgba(0,0,0,.1);
    padding: 10px 20px;
}
.img_neumaticos{
  width:auto;
}
.enlace_neumaticos{
  color:#000000;
}
.ico_btn{
  background-color:transparent;
  border:1px solid rgb(121, 147, 252);
  border-radius:15px;
  }
  .fusion-modal h1{ color:#000 !important; }

  .another_request{
    background-color: rgb(121, 147, 252);
    border-color: rgb(121, 147, 252);
    color: white;
    box-sizing: border-box;
    border-width: 2px;
    font-size: 14px;
    font-weight: 600;
    padding: 6px 12px;
    min-width: 140px;
}

</style>



// WEBPACK FOOTER //
// src/components/PeticionForm.vue